import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import d2MenuSide from './components/menu-side';
import d2MenuHeader from './components/menu-header';
import d2Tabs from './components/tabs';
import d2HeaderFullscreen from './components/header-fullscreen'; // import d2HeaderLocales from './components/header-locales'
// import d2HeaderSearch from './components/header-search'

import d2HeaderTheme from './components/header-theme';
import d2HeaderUser from './components/header-user';
import d2HeaderLog from './components/header-log';
import d2HeaderNotify from './components/header-notify';
import { mapState, mapGetters, mapActions } from 'vuex';
import mixinSearch from './mixins/search';
import { menuAside, clearMenu } from '@/menu';
export default {
  name: 'd2-layout-header-aside',
  mixins: [mixinSearch],
  components: {
    d2MenuSide: d2MenuSide,
    d2MenuHeader: d2MenuHeader,
    d2Tabs: d2Tabs,
    d2HeaderFullscreen: d2HeaderFullscreen,
    d2HeaderTheme: d2HeaderTheme,
    d2HeaderUser: d2HeaderUser,
    d2HeaderLog: d2HeaderLog,
    d2HeaderNotify: d2HeaderNotify
  },
  data: function data() {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: '200px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '65px',
      menuActive: false,
      lastRouter: '',
      tempMenuList: {},
      randBackgroundColor: ['#EBF1F6', '#DDE8F0', '#F5F7FA', '#E4E9EE', '#F5F8FB'],
      profile: {},
      timeoutId: null,
      // 用于存储定时器ID
      inactivityInterval: 40 * 60 * 1000,
      // 40分钟的毫秒数
      checkInterval: 1000 * 60 // 每分钟检查一次

    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState('d2admin', {
    keepAlive: function keepAlive(state) {
      return state.page.keepAlive;
    },
    grayActive: function grayActive(state) {
      return state.gray.active;
    },
    transitionActive: function transitionActive(state) {
      return state.transition.active;
    },
    asideCollapse: function asideCollapse(state) {
      return state.menu.asideCollapse;
    },
    asideTransition: function asideTransition(state) {
      return state.menu.asideTransition;
    }
  })), mapState('d2admin/menu', ['aside', 'asideCollapse', 'asideTransition'])), mapGetters('d2admin', {
    themeActiveSetting: 'theme/activeSetting'
  })), {}, {
    /**
     * @description 用来实现带参路由的缓存
     */
    routerViewKey: function routerViewKey() {
      // 默认情况下 key 类似 __transition-n-/foo
      // 这里的字符串操作是为了最终 key 的格式和原来相同 类似 __transition-n-__stamp-time-/foo
      var stamp = this.$route.meta["__stamp-".concat(this.$route.path)] || '';
      return "".concat(stamp ? "__stamp-".concat(stamp, "-") : '').concat(this.$route.path);
    },

    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup: function styleLayoutMainGroup() {
      return this.themeActiveSetting.backgroundImage ? {
        backgroundImage: "url('".concat(this.$baseUrl).concat(this.themeActiveSetting.backgroundImage, "')")
      } : {};
    }
  }),
  mounted: function mounted() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
  },
  created: function created() {
    var that = this; // 监听用户的活动，例如键盘、鼠标、触摸等事件

    window.addEventListener('mousemove', that.handleActivity);
    window.addEventListener('keydown', that.handleActivity);
    window.addEventListener('touchmove', that.handleActivity); // 每分钟检查一次用户的活动

    that.checkActivity(); // 记录用户的活动时间

    that.handleActivity();
  },
  destroyed: function destroyed() {
    var that = this; // 组件销毁时移除事件监听器

    window.removeEventListener('mousemove', that.handleActivity);
    window.removeEventListener('keydown', that.handleActivity);
    window.removeEventListener('touchmove', that.handleActivity); // 清除定时器

    clearTimeout(that.timeoutId);
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('d2admin/account', ['logout'])), mapActions('d2admin/menu', ['asideCollapseToggle'])), {}, {
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside: function handleToggleAside() {
      this.asideCollapseToggle();
    },
    menuHeaderClick: function menuHeaderClick(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (e.index === '/index') {
                  _this.menuActive = false;
                  _this.lastRouter = e.index;
                } else {
                  // if (e.index !== this.lastRouter) {
                  //   this.menuActive = true
                  // } else {
                  //   this.menuActive = !this.menuActive
                  // }
                  _this.menuActive = true; // this.lastRouter = e.index
                }

                _this.$nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          // let mmm = require('../../menu/modules/' + e.index.substr(1))
                          // await loadMenuAside()
                          _this.tempMenuList = [];
                          menuAside.forEach(function (row) {
                            if (row.path === e.index) {
                              _this.tempMenuList = row;
                              console.log('this.tempMenuList', _this.tempMenuList);
                            }
                          }); // this.tempMenuList = mmm.default

                          if (!_this.menuActive && e.index !== '/index') {
                            _this.$router.back();
                          }

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    navClick: function navClick(path) {
      this.menuActive = false;
      this.$router.push({
        path: path
      });
    },
    sideClick: function sideClick() {
      this.menuActive = false;
    },
    getBackgroundColor: function getBackgroundColor() {
      var color = this.randBackgroundColor[parseInt(Math.random() * 4)];
      return color;
    },
    settings: function settings() {
      var that = this;
      that.$refs.SettingsComponents.init();
    },
    agencyReload: function agencyReload() {
      var that = this;
      that.$refs.d2HeaderNotify.init();
    },
    handleActivity: function handleActivity() {
      var that = this; // 用户有活动，重置定时器

      clearTimeout(that.timeoutId);
      that.timeoutId = setTimeout(that.toLogout, that.inactivityInterval);
    },
    checkActivity: function checkActivity() {
      var that = this; // 检查用户的最后活动时间

      var lastActivity = localStorage.getItem('lastActivity') || new Date().getTime();
      var currentTime = new Date().getTime();

      if (currentTime - lastActivity > that.inactivityInterval) {
        // 超过40分钟无活动，执行退出逻辑
        console.log('注销登录');
        that.toLogout();
      } else {
        // 继续检查
        if (that.$route.name !== 'login') {
          setTimeout(that.checkActivity, that.checkInterval);
        }
      }
    },
    toLogout: function toLogout() {
      var that = this; // 执行退出逻辑，例如清除本地存储的用户信息

      localStorage.removeItem('lastActivity');
      that.logout();
    }
  })
};